var render = function render(_c, _vm) {
  return _c("a-menu-item", {
    key: _vm.props.currentRoute.path
  }, [_c(_vm.injections.components.appLink, {
    tag: "component",
    attrs: {
      to: _vm.props.currentRoute.path
    }
  }, [_vm.props.currentRoute.meta.icon ? _c("svg-icon", {
    attrs: {
      icon: _vm.props.currentRoute.meta.icon
    }
  }) : _vm._e(), _c("span", {
    staticClass: "menu-title",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.props.currentRoute.meta.title))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };